import { Type } from '@angular/core';
import { ActivityItem } from '@app/courses/models/activity-item';

export class LearningActivityItem {
  constructor(public component: Type<any>, public activityItem: ActivityItem) {}
}
